import React, { Component } from 'react';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardGroup, Table,
  Progress,
  Collapse, Button, Fade,
  ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText,
  Input,
  InputGroup,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Form
} from 'reactstrap';
import moment from 'moment';

import { IMAGE } from "common-import/constants";
import { inject, observer } from "mobx-react"
import { makeInput } from "common-import/custom";

@inject("contactStore", "companyInfoStore") @observer
class ContactList extends Component {

  constructor(props) {
    super(props);
  }

  state = {
    keyword: "",
    message: "",
    list: [],
    listCompany: [],
    contactList: []
  }

  async componentDidMount() {
    // let result = await this.props.userStore.adminList({});
    // console.log(result);
    // this.props.participantStore.list();
  }

  renderRow(data, index) {
    return (
      <tr key={"listuser"+index}>
        <td className="text-center">
          <div className="avatar">
            <img src={data.avatar || IMAGE} className="img-avatar" alt="admin@bootstrapmaster.com"/>
            {/* <span className="avatar-status badge-success"></span> */}
          </div>
        </td>
        <td>
          <div>{data.name}</div>
          <div className="small text-muted">
            <span>Email</span>: {data.email}
          </div>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">
              <strong>{data.tel}</strong>
            </div>
          </div>
        </td>
        <td>
          <div className="clearfix">
            <div className="float-left">
              <strong>{data.jobTitle}</strong>
            </div>
          </div>
        </td>
        <td>
          <div className="small text-muted">{data.companyTaxCode}</div>
        </td>
      </tr>
      
    )
  }

  render() {
    const { list, message, listCompany, contactList } = this.state;
    return (
      <div className="animated fadeIn">
        <Form onSubmit={this.search}>
          <FormGroup row>
            <Col md="12">
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <Button type="button" color="primary" onClick={this.search}><i className="fa fa-search"></i> Search</Button>
                </InputGroupAddon>
                {makeInput(this, "keyword")(<Input type="text" id="input1-group2" name="input1-group2" placeholder="Tìm danh sách liên hệ theo tên công ty hoặc mã số thuế" />)}
              </InputGroup>
            </Col>
          </FormGroup>
        </Form>
        <Row>
          <Col xs="12" sm="12">
            {message !== "" && <p style={{ marginBottom: 20, testAlign: "center", display: "block", fontWeight: "bold", color: "green" }}>{message}</p>}
            {this.renderCompanyList()}
            <Table hover responsive className="table-outline mb-0 d-sm-table">
              <thead className="thead-light">
                <tr>
                  <th className="text-center"><i className="icon-people"></i></th>
                  <th>Contact</th>
                  <th>Telephone</th>
                  <th>Job title</th>
                  <th>Company Code</th>
                </tr>
              </thead>
              <tbody>
                {contactList.map((val, index) => this.renderRow({
                      name: val.name,
                      email: val.email,
                      tel: val.phone,
                      jobTitle: val.position,
                      companyTaxCode: val.companyTaxCode,
                      avatar: val.avatar
                    }, index))
                }
              </tbody>
            </Table>
          </Col>
        </Row>

      </div>
    );
  }

  renderCompanyList = () => {
    const { listCompany } = this.state
    return (
      <div style={{ maxHeight: 100, overflow: "auto", marginBottom: 20 }}>
        {listCompany.map((val, index) => (
          <p className="cursor hover-underline" key={"comp"+index} onClick={()=>this.findContact(val)}>{val.tenChinhThuc}</p>
        ))}
      </div>
    )
  }

  search = async (e) => {
    !!e && e.preventDefault();
    this.setState({ message: "Đang tìm.." });
    const { contactStore, companyInfoStore } = this.props;
    const { keyword } = this.state;
    const isNumber = !isNaN(keyword);
    const findObject = isNumber ? { taxId: keyword } : { name : keyword };
    let companyResult = await companyInfoStore.find(findObject);
    console.log(companyResult);
    if (!!companyResult.error) {
      this.setState({ message: "", companyList: companyResult.data });
      return window.toast.error("Có lỗi xảy ra, vui lòng thử lại " + JSON.stringify(companyResult.error));
    }
    this.setState({ listCompany: companyResult.data, message: companyResult.data.length > 0 ? "" : "Không tìm thấy công ty" })

  }

  findContact = async ({maDoanhNghiep, tenChinhThuc}) => {
    const { contactStore } = this.props;
    let res = await contactStore.getContactList(maDoanhNghiep);
    if (!!res.error) return window.toast.error("Có lỗi xảy ra, vui lòng thử lại " + JSON.stringify(res.error));
    console.log(res);
    this.setState({ 
      contactList: res.data, 
      message: res.data.length === 0 ? `${tenChinhThuc} hiện chưa có contact` : `Hiển thị ${res.data.length} contact của ${tenChinhThuc}` 
    });
  }
}

export default ContactList;


// WEBPACK FOOTER //
// ./src/views/Contacts/ContactList.js